import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MEDREFILL_INSTITUTIONS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMedRefillInstitutionsResponsePayload,
  GetPublicMedRefillInstitutionsRequestPayload,
} from '../types/getMedRefillInstitutions.type';

export const TAG_PUBLIC_MEDREFILL_INSTITUTIONS = 'getPublicMedRefillInstitutions';

export const getPublicMedRefillInstitutions = <T extends BuilderType>(builder: T) =>
  builder.query<GetMedRefillInstitutionsResponsePayload, GetPublicMedRefillInstitutionsRequestPayload>({
    providesTags: [TAG_PUBLIC_MEDREFILL_INSTITUTIONS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PUBLIC_MEDREFILL_INSTITUTIONS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedRefillInstitutionsResponsePayload>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
